import { KeyboardAvoidingView as RNKeyboardAvoidingView } from "react-native-keyboard-controller";

import { KeyboardAvoidingViewProps } from "./types";
import { useKeyboardAvoidingView } from "./controller";

export const KeyboardAvoidingView = ({
  children,
  keyboardVerticalOffset = 0,
  enabled = true
}: KeyboardAvoidingViewProps) => {
  const { isWeb } = useKeyboardAvoidingView();

  if (isWeb) {
    return <>{children}</>;
  }

  return (
    <RNKeyboardAvoidingView
      behavior={"padding"}
      keyboardVerticalOffset={keyboardVerticalOffset}
      enabled={enabled}
      style={{ flex: 1 }}
    >
      {children}
    </RNKeyboardAvoidingView>
  );
};
